import { CanActivateFn, CanMatchFn } from '@angular/router';

export const onboardingGuardCanActivate: CanActivateFn = (route, state) => {
  return true;
};

export const onboardingGuardCanMatch: CanMatchFn = (route, state) => {
  return true;
}
